const splitCharacter = "^";

export const toBeeCompatibleForm = (payload) => {
  if (payload) {
    log("toBeeCompatibleForm.payload", payload);
    let title = payload.title;
    let fields = getFields(payload.fields);
    log("toBeeCompatibleForm => getFields done");
    let layout = getLayout(payload.fields);
    log("toBeeCompatibleForm => getLayout done");
    let form = {
      defaultForm: {
        structure: {
          title,
          fields,
          layout,
        },
      },
    };
    log("form", form);
    return form;
  } else {
    return {};
  }
};

const getFields = (payload) => {
  let fields = {};
  payload &&
    payload.forEach((_) => {
      let field = {
        type: _.fieldType,
        label: _.label ? _.label : "",
        canBeRemovedFromLayout: _.canBeRemovedFromLayout,
        removeFromLayout: _.removeFromLayout,
        canBeModified: _.canBeModified,
        attributes: {
          class: _.class ? _.class : _.fieldName,
          hidden: _.isHidden
        },
      };
      let options = [];
      switch (_.fieldType) {
        case "text":
          field.attributes.required = _.isRequired;
          field.attributes.id = _.fieldName;
          if (_.fieldName.toLowerCase().includes("phone")) {
            field.attributes.pattern = "[(][0-9]{3}[)] [0-9]{3}-[0-9]{4}";
            field.attributes.title = "please enter valid phone (123) 456-7890";
            field.attributes.class = `${field.attributes.class} apply-phone-mask`;
          }
          break;
        case "date":
          field.attributes.id = _.fieldName;
          field.attributes.required = _.isRequired;
          field.attributes.class = `${field.attributes.class} apply-date-min-max`;
          break;
        case "email":
          field.attributes.required = _.isRequired;
          field.attributes.id = _.fieldName;
          field.attributes.title = "please enter valid email [test@test.com]";
          field.attributes.placeholder =
            _.defaultValue !== null ? _.defaultValue : "";
          break;
        case "submit":
          field.label = "";
          if (_.fieldName.toLowerCase() === "cancel") {
            field.attributes.class = `${field.attributes.class} apply-on-cancel-click`;
          }
          field.attributes.value = _.label;
          field.attributes.id = _.fieldName;
          break;
        case "radio":
          field.attributes.name = _.fieldName;
          field.attributes.required = _.isRequired;
          if (_.defaultValue !== null) {
            const props = `defaultValue: ${_.defaultValue}`;
            field.attributes.itemprop = `${props}`;
          }
          options = [];
          if(_.choices) {
            _.choices.map((choice) => {
              var label = choice.label
                ? choice.label
                : choice.title
                ? choice.title
                : "Default Label";
              options.push({
                type: "option",
                label: label,
                value: choice.value,
              });
            });
          }
          field.options = options;
          break;
        case "select":
          field.attributes.id = _.fieldName;
          field.attributes.required = _.isRequired;
          field.attributes.value = `${
            _.defaultValue !== null ? _.defaultValue : "0"
          }`;
          const props = `parent: ${_.parentField}`;
          field.attributes.itemprop = `${props}`;

          options = [];

          // Set Default Selection to Empty
          if (_.fieldName !== "multi_SnowReportAmount") {
            if (_.parentField !== null) {
              options.push({
                type: "option",
                label: "",
                value: `0${splitCharacter}empty${splitCharacter}0`,
              });
            } else {
              options.push({
                type: "option",
                label: "",
                value: "0",
              });
            }
          } else {
            field.attributes.value = `${
              _.defaultValue !== null ? _.defaultValue : "123"
            }`;
          }
          
          if(_.choices) {
            _.choices.map((choice) => {
              let value =
                choice.parentLookupId !== null
                  ? `${choice.lookupId}${splitCharacter}${choice.value}${splitCharacter}${choice.parentLookupId}`
                  : `${choice.lookupId}`;
              options.push({
                type: "option",
                label: choice.label
                  ? choice.label
                  : choice.title
                  ? choice.title
                  : "Default Label",
                value: value,
              });
            });
          }
          field.options = options;

          break;
        case "checkbox":
          field.attributes.id = _.fieldName;
          field.attributes.required = _.isRequired;
          if (_.defaultValue !== null) {
            var defaultValues = _.defaultValue
              .trim()
              .toLowerCase()
              .split(",")
              .map((i) => i.trim())
              .join(splitCharacter);
            const props = `defaultValue: ${defaultValues}`;
            field.attributes.itemprop = `${props}`;
          }
          field.attributes.name = _.fieldName;
          options = [];
          if(_.choices) {
            _.choices.map((choice) => {
              options.push({
                type: "option",
                label: choice.label
                  ? choice.label
                  : choice.title
                  ? choice.title
                  : "Default Label",
                value: choice.value,
              });
            });
          }
          field.options = options;
          break;
        case "hidden":
          field.attributes.id = _.fieldName;
          field.attributes.name = _.fieldName;
          field.attributes.value = _.defaultValue;
          break;
        default:
          break;
      }
      fields[_.fieldName] = field;
    });
  return fields;
};

const getLayout = (payload) => {
  const layout = [];
  payload &&
    payload.forEach((_) => {
      if (!layout[_.rowId - 1]) {
        layout[_.rowId - 1] = [];
      }
      layout[_.rowId - 1].push({
        name: _.fieldName,
        row: _.rowId,
        sort: _.sortOrder,
      });
    });
  const sortedLayout = getLayoutNames(layout);
  return sortedLayout;
};

const getLayoutNames = (layout) => {
  layout.sort(sortLayout);
  return layout
    .filter((_) => _)
    .map((items, index) => {
      return items.map((_item, _index) => {
        return _item.name;
      });
    });
};

const sortLayout = (a, b) => {
  if (a.length > 1) {
    a.sort((x, y) => {
      var _sort = x.sort - y.sort;
      return _sort;
    });
  }
  if (b.length > 1) {
    b.sort((x, y) => {
      var _sort = x.sort - y.sort;
      return _sort;
    });
  }
  var sort = a[0].row - b[0].row;
  return sort;
};

const log = (message, payload) => {
  // if (payload) {
  //   console.log(`FL.FC => ${message}`, payload);
  // } else {
  //   console.log(`FL.FC => ${message}`);
  // }
};

export default {
  toBeeCompatibleForm,
};
